import React from 'react';
import AppRoutes from './components/AppRoutes';
import { AuthenticationProvider } from './hooks/useAuthentication';
import { ApiProvider } from './hooks/useApi';
import { ConfigProvider } from './hooks/useConfig';
import { BrowserRouter as Router } from 'react-router-dom';
import {
  LocalStorageProvider,
  UserProvider,
  NotificationProvider,
  GoogleMapCoordinatesProvider,
  EventProvider,
  AgentExtensionProvider,
  BrowserNotificationProvider,
  DataPopProvider,
  CaseIdProvider,
  E911CasesProvider,
  DialogProvider,
  CaseProvider,
  LoggingProvider,
} from './hooks';
import { SnackbarProvider } from 'notistack';
import {
  Activity,
  AgentExtensionActivity,
  BrowserExitPromptActivity,
} from './components';
import { injectColorDisabledInputGlobalStyle } from './styles/theme';

injectColorDisabledInputGlobalStyle();

function App() {
  return (
    <Router>
      <ConfigProvider>
        <LoggingProvider>
          <LocalStorageProvider>
            <AuthenticationProvider>
              <ApiProvider>
                <GoogleMapCoordinatesProvider>
                  <UserProvider>
                    <AgentExtensionProvider>
                      <DataPopProvider>
                        <SnackbarProvider>
                          <BrowserNotificationProvider>
                            <DialogProvider>
                              <NotificationProvider>
                                <EventProvider>
                                  <E911CasesProvider>
                                    <CaseIdProvider>
                                      <CaseProvider>
                                        <Activity />
                                        <AgentExtensionActivity />
                                        <BrowserExitPromptActivity />
                                        <AppRoutes />
                                      </CaseProvider>
                                    </CaseIdProvider>
                                  </E911CasesProvider>
                                </EventProvider>
                              </NotificationProvider>
                            </DialogProvider>
                          </BrowserNotificationProvider>
                        </SnackbarProvider>
                      </DataPopProvider>
                    </AgentExtensionProvider>
                  </UserProvider>
                </GoogleMapCoordinatesProvider>
              </ApiProvider>
            </AuthenticationProvider>
          </LocalStorageProvider>
        </LoggingProvider>
      </ConfigProvider>
    </Router>
  );
}

export default App;
